import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: 'http://cddcec1e8ddb8b8dbb91d51c6745bac0@172.16.11.106:9000/8',
  environment: 'production', // optional
  release: 'admin-portal',
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts